import { useNavigate } from "react-router-dom";
import GoalSelect from "@/components/story/GoalSelect";
import { loadState, saveState } from "@/lib/story-store";

const Archetypes = () => {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-background">
      <GoalSelect
        onSelect={(goal) => {
          const state = loadState();
          saveState({ ...state, goal });
          navigate("/make-gentle-tale");
        }}
        onBack={() => navigate("/")}
      />
    </main>
  );
};

export default Archetypes;
